import {Championships, Events, MatchContracts, Matches, Superstars, TagTeams} from "./models.js";

function Tournament(name, type, rounds, matchesAtEvent = null, participantsAdvancing = null,
                    knockoutRounds = null, numberOfGroups = null) {

    // Integer
    const xp = 0;
    const startingXp = 0;
    const cost = 150;

    // String
    const prestige = 'C';
    const stage = null;
    const winnerName = null;
    const matchContractName = null;
    const awardName = null;
    const status = null;

    // Boolean
    const annualTournament = false;

    // Objects
    const companiesData = {};

    // Foreign keys
    const companyId = null;
    const winnerSuperstarId = null;
    const winnerTagTeamId = null;
    const eventId = null;

    return {
        name,
        type,
        rounds,
        matchesAtEvent,
        participantsAdvancing,
        knockoutRounds,
        numberOfGroups,
        xp,
        startingXp,
        cost,
        prestige,
        stage,
        winnerName,
        matchContractName,
        awardName,
        status,
        annualTournament,
        companiesData,
        companyId,
        winnerSuperstarId,
        winnerTagTeamId,
        eventId,
    };
}

function getTournamentWinnerSuperstar(tournament) {
    return Superstars.find({'$loki': tournament.winnerSuperstarId})[0];
}

function getTournamentWinnerTagTeam(tournament) {
    return TagTeams.find({'$loki': tournament.winnerTagTeamId})[0];
}

function getTournamentEvent(tournament) {
    return Events.find({'$loki': tournament.eventId})[0];
}

function addTournamentMatches(tournament, matches) {
    matches.forEach(c => {
        c.tournamentId = tournament.$loki
    });
}

function removeTournamentMatches(tournament, matches) {
    matches.forEach(c => {
        c.tournamentId = null
    });
}

function getTournamentMatches(tournament) {
    return Matches.find({'tournamentId': tournament.$loki});
}

function addTournamentChampionships(tournament, championships) {
    championships.forEach(c => {
        c.tournamentId = tournament.$loki
    });
}

function removeTournamentChampionships(tournament, championships) {
    championships.forEach(c => {
        c.tournamentId = null
    });
}

function getTournamentChampionships(tournament) {
    return Championships.find({'tournamentId': tournament.$loki});
}

function addTournamentMatchContracts(tournament, matchContracts) {
    matchContracts.forEach(c => {
        c.tournamentId = tournament.$loki
    });
}

function removeTournamentMatchContracts(tournament, matchContracts) {
    matchContracts.forEach(c => {
        c.tournamentId = null
    });
}

function getTournamentMatchContracts(tournament) {
    return MatchContracts.find({'tournamentId': tournament.$loki});
}


export { Tournament, getTournamentEvent, getTournamentWinnerSuperstar, getTournamentWinnerTagTeam,
    addTournamentChampionships, removeTournamentChampionships, getTournamentChampionships,
    addTournamentMatchContracts, removeTournamentMatchContracts, getTournamentMatchContracts, addTournamentMatches,
    removeTournamentMatches, getTournamentMatches }
